import { QueryPanel } from '@/components/chat/QueryPanel'
import { ResultsPanel } from '@/components/ResultsPanel'

export function QueryPage() {
  return (
    <div className="grid gap-4 lg:h-full lg:min-h-0 lg:grid-cols-[minmax(320px,32%)_1fr]">
      <div className="h-[68vh] min-w-0 lg:h-full lg:min-h-0">
        <QueryPanel />
      </div>
      <div className="h-[68vh] min-w-0 lg:h-full lg:min-h-0">
        <ResultsPanel />
      </div>
    </div>
  )
}
